module.exports = __webpack_public_path__ + "img/media__image-icon.a21b3d11.svg";